import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { ComponentType, Suspense } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router-dom';

import { Spinner } from '../loaders/Spinner';

export const PageContent = styled('div')({
	flex: '1 1 auto',
	overflowX: 'auto',
});

export interface PageContentTabParams {
	ErrorFallbackComponent: ComponentType<FallbackProps>;
}

export const PageContentTab = ({
	ErrorFallbackComponent,
}: PageContentTabParams) => {
	const { pathname } = useLocation();
	return (
		<Box
			data-testid="page-content-tab"
			sx={{
				flex: '1 1 auto',
				overflowX: 'auto',
				minHeight: 300,
			}}>
			<ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
				{/* Added to properly handle routes lazy loading using RRD v7 Fix done based on
				 ** https://github.com/remix-run/react-router/issues/12474#issuecomment-2538281149 - temp solution is to add a key to Suspense
				 */}
				<Suspense fallback={<Spinner />} key={pathname}>
					<Outlet />
				</Suspense>
			</ErrorBoundary>
		</Box>
	);
};
